module.exports = __webpack_public_path__ + "img/SH2D_300002.949cde2c.png";